<template>
    <div
        v-show="popper_isVisible"
        ref="popper"
        class="popover px-3 shadow-none"
        v-bind:class="popper_arrowClass()">
        <div
            data-popper-arrow
            class="popover-arrow" />
        <slot />
    </div>
</template>

<script setup>
    import { ref, onMounted } from "vue";
    import { usePopper, POPPER_PLACEMENT } from "Components/page/Navigation/popperComposable";

    const {
        popper_popperReference,
        popper_popperPlacement,
        popper_arrowClass,
        popper_useHideOnOutsideClick,
        popper_isVisible,
        popper_hide,
        popper_show
    } = usePopper();

    const emit = defineEmits(["popper-closed", "popper-opened"]);

    // Refs
    const popper = ref(null);

    const props = defineProps({
        placement: { type: String, required: false, default: POPPER_PLACEMENT.right }
    });

    // Set popper values
    popper_popperPlacement.value = props.placement;
    popper_useHideOnOutsideClick.value = false;
    onMounted(() => {
        popper_popperReference.value = popper.value;
    });

    function dismiss() {
        popper_hide();
        emit("popper-closed");
    }

    async function tryShow(elementRef, showDuration = null) {
        popper_show(elementRef);
        emit("popper-opened");

        if (showDuration) {
            setTimeout(function () {
                popper_hide();
                emit("popper-closed");
            }, showDuration);
        }
    }

    defineExpose({
        dismiss,
        tryShow
    });
</script>

<style lang="scss" scoped>
    .popover {
        font-size: 1rem;
    }
</style>
